module.exports = __webpack_public_path__ + "screenshot_4.c9df8b8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/DeveloperIntegration/Guides/screenshot_4.png
// module id = 3000
// module chunks = 0